import { useQuery } from "@apollo/client";
import { UNIVERSITY_QUERY } from "@/pages/education/universities/[universityId]/queries";

export function useUniversityExists(universityId: string | undefined) {
  const { data, loading } = useQuery(UNIVERSITY_QUERY, {
    variables: { legacyId: universityId },
    skip: !universityId,
    errorPolicy: "all"
  });

  const universityNotFound = !loading && (!data?.universities || data.universities.length === 0);

  return {
    universityNotFound,
    loading,
    university: data?.universities?.[0] || null
  };
}
